// Scope all DOM queries to this section to avoid conflicts with other sections on the same page
const mmSectionEl = document.getElementById('shopify-section-' + window.__mmCollectionSectionId);
const form = mmSectionEl.querySelector("#collectionFacetsForm");
const filterButtonOpen = form.querySelector(".mm-collection-filter-button");
const wrapperMobile = form.querySelector(".mm-collection-facets-container");
const filterButtonClose = wrapperMobile.querySelector(".mm-drawer-collection-header svg");

// Helper: scope querySelector to this section (live DOM)
function mmQs(selector) { return mmSectionEl.querySelector(selector); }
function mmQsa(selector) { return mmSectionEl.querySelectorAll(selector); }

async function refreshCollectionPageWithFilters(url_filters, submit ) {
	let currentUrl = "//" + location.host + location.pathname;
	const sectionId = window.__mmCollectionSectionId;
	// Coming soon sans stock, demandés en parallèle (mm_collection_coming_soon.js)
	const comingSoonRequest = mmComingSoonFetch(url_filters);
	let sectionHtml;
	try {
		// Use Shopify Section Rendering API: fetch only this section's HTML
		const response = await fetch(currentUrl + "?" + url_filters + "&sections=" + sectionId);
		const json = await response.json();
		sectionHtml = json[sectionId];
	} catch (err) {
		console.error("Erreur lors du chargement des filtres:", err);
		return;
	}
	const parser = new DOMParser();
	const newSectionDoc = parser.parseFromString(sectionHtml, 'text/html');
	const newSectionEl = newSectionDoc.body;

    function mmRefreshActiveFiltersBar() {
        const newBar = newSectionEl.querySelector(".mm-active-filters-bar");
        const currentBar = mmQs(".mm-active-filters-bar");

        if (!currentBar && newBar) {
            const anchor = form?.querySelector(".mm-filters-sort-by-container");
            if (form && anchor) {
            anchor.insertAdjacentHTML("beforebegin", newBar.outerHTML);
            }
            return;
        }

        if (currentBar && newBar) {
            currentBar.innerHTML = newBar.innerHTML;
            return;
        }

        if (currentBar && !newBar) {
            currentBar.innerHTML = "";
        }
    }

    if (submit) {
        let newSection = newSectionEl.querySelector(".mm-collection-grid");
        mmQs(".mm-collection-grid").innerHTML = newSection.innerHTML;

        let newNum = newSectionEl.querySelector(".mm-num-products");
        mmQs(".mm-num-products").innerHTML = newNum.innerHTML;

        let newLoadMore = newSectionEl.querySelector(".mm-grid-coll-loadmore-container");
        if (newLoadMore) {
            mmQs(".mm-grid-coll-loadmore-container").innerHTML = newLoadMore.innerHTML;
        } else if (mmQs(".mm-grid-coll-loadmore-container")) {
            mmQs(".mm-grid-coll-loadmore-container").innerHTML = "";
        }
        const newGroupsContainer = newSectionEl.querySelector(".mm-filters-groups-container");
        const currentGroupsContainer = mmQs(".mm-filters-groups-container");

        if (newGroupsContainer && currentGroupsContainer) {
            let mmOpenGroupKey = null;

            if (mmIsDesktop()) {
                const openGroup = mmQs(".filter-group.mm-open");
                if (openGroup) {
                mmOpenGroupKey = Array.from(openGroup.classList).find(
                    (c) => c !== "filter-group" && c !== "mm-open"
                );
                }
            }

            currentGroupsContainer.innerHTML = newGroupsContainer.innerHTML;

            if (form) form.dataset.mmDesktopDropdownsInit = "0";
            mmInitDesktopFacetDropdowns();

            if (mmIsDesktop() && mmOpenGroupKey) {
                const reopened = mmQs(`.filter-group.${CSS.escape(mmOpenGroupKey)}`);
                if (reopened) {
                reopened.classList.add("mm-open");
                const head = reopened.querySelector(".mm-dropdown");
                if (head) head.classList.add("mm-active");
                }
            }
        }

        if (typeof mmRefreshActiveFiltersBar === "function") {
        mmRefreshActiveFiltersBar();
        }
    } else {
        let newFilters = newSectionEl.querySelectorAll(".filter-group-display__list");
        newFilters.forEach((newFilter, index) => {
            mmQsa(".filter-group-display__list")[index].innerHTML = newFilter.innerHTML;
        });

        let newSubmitBtn = newSectionEl.querySelector(".mm-drawer-collection-submit-btn");
        mmQs(".mm-drawer-collection-submit-btn").innerHTML = newSubmitBtn.innerHTML;
        mmRefreshActiveFiltersBar();
    }
	productCardSlidersInit('body');
	ReloadSmartWishlist();
	if (typeof mmInitFilterScrollbar === 'function') mmInitFilterScrollbar();

	const btnsCloseWishlistAll = document.querySelectorAll(".mm-pc-whishlist-modal-close");
	const ctaWishlistAll = document.querySelectorAll(".mm-pc-wishlist-button")

	const productModalFilter = document.querySelector('.mm-mobile-wishlist-modal-filter');

	function closeWishlistModal(btnCloseWishlist) {
	let productModal;
	if (window.innerWidth < 768) {
		productModal = btnCloseWishlist.closest(".mm-product-card-wishlist-modal-mobile");
	} else {
		productModal = btnCloseWishlist.closest(".mm-product-card-wishlist-modal");
	}
	productModal.classList.remove("mm-open");
	productModalFilter.classList.remove("mm-open");
	document.querySelector("html").classList.remove("stop-scrolling");
	startLenis();
	}

	btnsCloseWishlistAll.forEach((btnCloseWishlist) => {
		btnCloseWishlist.addEventListener("click", () => {
		closeWishlistModal(btnCloseWishlist);
		});
	});

	ctaWishlistAll.forEach((ctaWishlist) =>{
		ctaWishlist.addEventListener("click", () => {
			closeWishlistModal(ctaWishlist);
		if (window.innerWidth < 768) {
		const productCard = document.querySelector(ctaWishlist.dataset.targetProductCard);
		productCard.classList.remove("mm-unbookmarked");
		productModalFilter.classList.remove("mm-open");
		document.querySelector("html").classList.remove("stop-scrolling");
		}
		});
	});

	// Preserve view param in URL for subsequent requests
	const viewInUrl = new URLSearchParams(window.location.search).get('view');
	const urlSuffix = viewInUrl ? '&view=' + encodeURIComponent(viewInUrl) : '';
	window.history.replaceState(null, document.title, currentUrl + "?" + url_filters + urlSuffix);

	const newNumProducts = newSectionEl.querySelector(".mm-num-products");
	const productsCount = newNumProducts ? parseInt(newNumProducts.dataset.mmCount, 10) || 0 : 0;
	mmComingSoonApply(mmSectionEl, await comingSoonRequest, productsCount, submit);
}

function httpGet(theUrl) {
	var xmlHttp = null;

	xmlHttp = new XMLHttpRequest();
	xmlHttp.open("GET", theUrl, false);
	xmlHttp.send(null);
	return xmlHttp.responseText;
}

async function fakeSubmitForm(submit = true) {
	let url_filters = new URLSearchParams(new FormData(form)).toString();
	if (url_filters && url_filters.includes('filter.')) {
		url_filters += '&filter.v.availability=1';
	}
	await refreshCollectionPageWithFilters(url_filters, submit);
}



window.addEventListener("DOMContentLoaded", (event) => {
  mmCheckDrawer();

});

function mmOpenFiltersMobile() {
	const header = document.querySelector('header');
  wrapperMobile.style.top = header.getBoundingClientRect().bottom + "px";
  wrapperMobile.style.height = "calc(var(--doc-height) - " + header.getBoundingClientRect().bottom + "px)";

  window.addEventListener("scroll", function () {
    wrapperMobile.style.top = header.getBoundingClientRect().bottom + "px";
    wrapperMobile.style.height = "calc(var(--doc-height) - " + header.getBoundingClientRect().bottom + "px)";
  });
	wrapperMobile.classList.add("mm-open");

	if (window.innerWidth < 900) {
		document.querySelector("html").classList.add("stop-scrolling");
	}
}
function mmCloseFiltersMobile() {
	wrapperMobile.classList.remove("mm-open");

	document.querySelector("html").classList.remove("stop-scrolling");
}

function mmCheckDrawer() {
	let currentUrl = document.location.href.indexOf("?open_filters");
	if (currentUrl !== -1 && window.innerWidth < 769) {
		mmOpenFiltersMobile();
	}
}

filterButtonOpen.addEventListener("click", function (event) {
	// Pas de drawer sur mobile pour cette variante
});
filterButtonClose.addEventListener("click", function (event) {
	mmCloseFiltersMobile();
});

function mmIsDesktop() {
  return window.matchMedia("(min-width: 769px)").matches;
}

function mmInitDesktopFacetDropdowns() {
	if (!form) return;

	const groups = Array.from(form.querySelectorAll(".filter-group"));
	if (!groups.length) return;

	if (mmIsDesktop()) {
		groups.forEach((g) => {
			g.classList.remove("mm-open");
			const head = g.querySelector(".mm-dropdown");
			if (head) head.classList.remove("mm-active");
		});
	}

	if (form.dataset.mmDesktopDropdownsInit === "1") return;
	form.dataset.mmDesktopDropdownsInit = "1";

	function closeAll(exceptGroup = null) {
		groups.forEach((g) => {
		if (exceptGroup && g === exceptGroup) return;
		g.classList.remove("mm-open");
		const head = g.querySelector(".mm-dropdown");
		if (head) head.classList.remove("mm-active");
		});
  	}

	function toggleGroup(group) {
		const isOpen = group.classList.contains("mm-open");
		closeAll();
		if (!isOpen) {
		group.classList.add("mm-open");
		const head = group.querySelector(".mm-dropdown");
		if (head) head.classList.add("mm-active");
		// Sur mobile : positionner le panel en fixed sous le bouton
		if (!mmIsDesktop()) {
			const panel = group.querySelector(".mm-dropdown-panel");
			if (panel) {
			const rect = group.getBoundingClientRect();
			panel.style.top = (rect.bottom + 10) + "px";
			panel.style.left = rect.left + "px";
			panel.style.width = rect.width + "px";
			}
		}
		}
	}

	groups.forEach((group) => {
		const header = group.querySelector(".mm-dropdown");
		const panel = group.querySelector(".mm-dropdown-panel");

		if (!header || !panel) return;

		header.addEventListener("click", (e) => {
		e.preventDefault();
		e.stopPropagation();
		toggleGroup(group);
		});

		panel.addEventListener("click", (e) => {
		e.stopPropagation();
		});
	});

	document.addEventListener("click", () => {
		closeAll();
	});

	document.addEventListener("keydown", (e) => {
		if (e.key === "Escape") closeAll();
	});

	window.addEventListener("resize", () => {
		closeAll();
	});
}

async function mmFacetOnChange() {
  await fakeSubmitForm(true);
}

window.addEventListener("DOMContentLoaded", () => {
  mmInitDesktopFacetDropdowns();
});

function mmBindActiveFiltersBarAjax() {
  const bar = mmQs(".mm-active-filters-bar");
  if (!bar) return;

  if (bar.dataset.mmBind === "1") return;
  bar.dataset.mmBind = "1";

  bar.addEventListener("click", (e) => {
    const link = e.target.closest("a");
    if (!link) return;

    const href = link.getAttribute("href");
    if (!href) return;

    e.preventDefault();

    const url = new URL(href, window.location.origin);
    const url_filters = url.searchParams.toString();
    const submit = true;

    refreshCollectionPageWithFilters(url_filters, submit);

    if (submit) {
      mmQsa(".filter-group.mm-open").forEach((g) => g.classList.remove("mm-open"));
    }
  });
}

(function mmInitActiveFiltersAjaxDelegation() {
  if (window.__mmActiveFiltersAjaxDelegation) return;
  window.__mmActiveFiltersAjaxDelegation = true;

  function mmSetActiveFiltersLoading(isLoading) {
    const bar = mmQs(".mm-active-filters-bar");
    if (!bar) return;
    bar.classList.toggle("mm-loading", !!isLoading);
    bar.setAttribute("aria-busy", isLoading ? "true" : "false");
  }

  document.addEventListener("click", (e) => {
    const link = e.target.closest(".mm-active-filters-bar a");
    if (!link) return;

    // Only handle clicks within our section
    if (!mmSectionEl.contains(link)) return;

    if (e.defaultPrevented) return;
    if (e.button && e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (link.target && link.target !== "_self") return;

    const href = link.getAttribute("href");
    if (!href) return;

    e.preventDefault();
    e.stopPropagation();

    const url = new URL(href, window.location.origin);
    const url_filters = url.searchParams.toString();

    const submit = true;

    mmSetActiveFiltersLoading(true);
    refreshCollectionPageWithFilters(url_filters, submit).then(() => {
        mmSetActiveFiltersLoading(false);
    }).catch(() => {
        mmSetActiveFiltersLoading(false);
    });
  });

})();

// Custom horizontal scrollbar for mobile filter bar
function mmInitFilterScrollbar() {
  if (window.innerWidth >= 769) return;

  const container = mmQs('.mm-filters-groups-container');
  if (!container) return;

  const existing = mmQs('.mm-filters-scrollbar');
  if (existing) existing.remove();

  if (container.scrollWidth <= container.clientWidth) return;

  const track = document.createElement('div');
  track.className = 'mm-filters-scrollbar';
  const thumb = document.createElement('div');
  thumb.className = 'mm-filters-scrollbar-thumb';
  track.appendChild(thumb);
  container.insertAdjacentElement('afterend', track);

  function updateThumb() {
    const ratio = container.clientWidth / container.scrollWidth;
    const thumbW = Math.max(track.clientWidth * ratio, 30);
    const maxLeft = track.clientWidth - thumbW;
    const scrollRatio = container.scrollLeft / (container.scrollWidth - container.clientWidth);
    thumb.style.width = thumbW + 'px';
    thumb.style.left = (scrollRatio * maxLeft) + 'px';
  }

  updateThumb();
  container.addEventListener('scroll', updateThumb, { passive: true });

  let dragStartX = 0, dragStartLeft = 0, dragging = false;

  thumb.addEventListener('pointerdown', (e) => {
    dragging = true;
    dragStartX = e.clientX;
    dragStartLeft = container.scrollLeft;
    thumb.setPointerCapture(e.pointerId);
    e.preventDefault();
  });

  thumb.addEventListener('pointermove', (e) => {
    if (!dragging) return;
    const dx = e.clientX - dragStartX;
    const thumbW = thumb.offsetWidth;
    const maxLeft = track.clientWidth - thumbW;
    const scrollRange = container.scrollWidth - container.clientWidth;
    container.scrollLeft = dragStartLeft + (dx / maxLeft) * scrollRange;
  });

  thumb.addEventListener('pointerup', () => { dragging = false; });
  thumb.addEventListener('pointercancel', () => { dragging = false; });
}

window.addEventListener('DOMContentLoaded', mmInitFilterScrollbar);
window.addEventListener('resize', mmInitFilterScrollbar);
